import { Box, Flex, Text, Image, Center } from "@chakra-ui/react";
import React, { useState } from "react";
import "../styles/contact.css";
import icn1 from "../images/social11.png";
import icn2 from "../images/social22.png";
import icn3 from "../images/social33.png";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
  const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
  const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
  // input change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.placeholder.toLowerCase()]: e.target.value,
    });
  };

  // sanitize
  const sanitize = (data) => {
    return {
      name: data.name.replace(/[<>]/g, ""),
      email: data.email.trim(),
      subject: data.subject.replace(/[<>]/g, ""),
      message: data.message.replace(/[<>]/g, ""),
    };
  };

  // submit
  const handleSubmit = (e) => {
    e.preventDefault();

    const cleanData = sanitize(formData);

    emailjs
      .send(SERVICE_ID, TEMPLATE_ID, cleanData, PUBLIC_KEY)
      .then(() => {
        alert("Message sent successfully 🚀");
        setFormData({ name: "", email: "", subject: "", message: "" });
      })
      .catch(() => {
        alert("Failed to send ❌");
      });
  };

  return (
    <Flex className="contact-section" id="contact">
      <Box className="sub-header">
        <span>Get in touch</span>
        <h2>Contact Me</h2>
      </Box>

      <Flex className="contact-details">
        <Box textAlign="left" className="contact-dis">
          <Text
            fontSize={{ lg: "5xl", md: "5xl", sm: "3xl", base: "2xl" }}
            fontWeight="bold"
            color="#1E2125"
          >
            <Box color="#ff014f">Madhya Pradesh </Box>, INDIA
          </Text>

          <Text
            fontSize={{ lg: "2xl", md: "2xl", sm: "2xl", base: "18px" }}
            mt="30px"
            mb={{ lg: "50px", md: "50px", sm: "40px", base: "15px" }}
            color="#878E99"
          >
            Sethi nagar, Ujjain
          </Text>

          <Text
            id="contact-email"
            color="#878E99"
            fontSize={{ lg: "2xl", md: "2xl", sm: "2xl", base: "18px" }}
          >
            vishalsharma331441@gmail.com
          </Text>

          <Text
            id="contact-phone"
            color="#878E99"
            fontSize={{ lg: "2xl", md: "2xl", sm: "2xl", base: "18px" }}
          >
            +91- 9039331441
          </Text>

          <Flex className="contact-icon-con">
            <Center>
              <a
                id="contact-github"
                target="_blank"
                href="https://github.com/Vishal-508"
              >
                <Image src={icn1} alt="github" />
              </a>
            </Center>

            <Center>
              <a
                id="contact-intagram"
                target="_blank"
                href="https://www.instagram.com/vishal_sharma1020/"
              >
                <Image src={icn2} alt="Instagram" />
              </a>
            </Center>

            <Center>
              <a
                id="contact-linkedin"
                target="_blank"
                href="https://linkedin.com/in/vishal-sharma-388956218"
              >
                <Image src={icn3} alt="linkedin" />
              </a>
            </Center>
          </Flex>
        </Box>

        {/* 🔥 FORM UPDATED */}
        <Box id="f-con" className="contact-form-container">
          <form onSubmit={handleSubmit}>
            <div className="form-name-email">
              <input
                type="text"
                placeholder="name"
                value={formData.name}
                onChange={handleChange}
              />

              <input
                type="text"
                placeholder="email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            <input
              type="text"
              placeholder="subject"
              id="subject"
              value={formData.subject}
              onChange={handleChange}
            />

            <br />

            <textarea
              id="textarea"
              placeholder="message"
              value={formData.message}
              onChange={handleChange}
            ></textarea>

            <button className="contact-btn" type="submit">
              Contact Me
            </button>
          </form>
        </Box>
      </Flex>

      <Center mt="160px">
        Made with ❤ in &nbsp;
        <Box color="#FF014F" fontWeight="bold">
          India.
        </Box>
      </Center>
    </Flex>
  );
};

export default Contact;
